const ArrowBottom = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="36" fill="none">
      <path
        fillRule="evenodd"
        d="M11.5 0c.339 0 .664.135.903.377a1.29 1.29 0 0 1 .374.909v30.323l8.039-8.092c.24-.241.565-.377.905-.377s.665.136.904.377a1.29 1.29 0 0 1 0 1.82L12.405 35.622c-.119.12-.26.215-.415.279a1.27 1.27 0 0 1-.979 0c-.155-.065-.296-.16-.415-.279L.375 25.337a1.29 1.29 0 0 1 0-1.82c.24-.241.565-.377.905-.377s.665.136.905.377l8.039 8.092V1.286a1.29 1.29 0 0 1 .374-.909c.24-.241.565-.377.903-.377z"
        fill="#fff"
      />
    </svg>
  );
};
export default ArrowBottom;
